export default __webpack_public_path__ + "static/media/joys550_incorrect_installation.7db34a5a.png";